export default __webpack_public_path__ + "static/media/mysticAlpines.5f436875.png";